var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.204,
    height: 21.5,
    viewBox: "0 0 17.204 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5642",
    "data-name": "Group 5642",
    transform: "translate(-3.398 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28974",
    "data-name": "Path 28974",
    d: "M14.54,2V4.486a14.36,14.36,0,0,0,.214,3.461,14.476,14.476,0,0,0,1.472,3.15l1.137,2.088c2.137,3.926,3.206,5.889,2.33,7.345l-.014.022C18.79,22,16.526,22,12,22s-6.79,0-7.679-1.448l-.014-.022c-.877-1.455.192-3.419,2.329-7.345L7.773,11.1a14.476,14.476,0,0,0,1.472-3.15,14.361,14.361,0,0,0,.214-3.461V2",
    fill: "none",
    stroke: "#f5f5f5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28975",
    "data-name": "Path 28975",
    d: "M9,16l.009,0",
    fill: "none",
    stroke: "#f5f5f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28976",
    "data-name": "Path 28976",
    d: "M15,18l.009,0",
    fill: "none",
    stroke: "#f5f5f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28977",
    "data-name": "Path 28977",
    d: "M8,2h8",
    fill: "none",
    stroke: "#f5f5f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28978",
    "data-name": "Path 28978",
    d: "M7.5,11.556c1-1.153,2.6-.322,4.5.762,2.5,1.426,4,.332,4.5-.7",
    fill: "none",
    stroke: "#f5f5f5",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestWorkflow);
export default __webpack_public_path__ + "static/media/test_workflow.30ad6f7117303ddbeb728a27793ea245.svg";
export { ForwardRef as ReactComponent };